<template>
  <div class="big">
    <div class="container">
      <div>
        <span class="title">歧黄医官APP</span>
        <el-radio-group v-model="detail.doctor_app">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="2">不开放</el-radio>
        </el-radio-group>
        <!-- <div style="padding-left: 110px">
          <span style="margin-right: 20px">医生设置</span>
          <el-button
            type="text"
            @click="
              adddoctor = true;
              isall_doctor = 1;
            "
            :disabled="
              module_id_array[0] ? !module_id_array.includes('562') : false
            "
            v-if="detail.doctor_type == 0"
          >未设置</el-button>
                        <span v-if="detail.doctor_type == 1">全部医生</span>
                          <span v-if="detail.doctor_type == 2">部分医生({{ detail.doctor_count }}人)</span>
                        <el-button
            type="text"
            @click="
              adddoctor = true;
              isall_doctor = detail.doctor_type;
            "
            style="margin-left: 10px"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('562') : false
            "
            v-if="detail.doctor_type != 0"
          >修改</el-button>
        </div> -->
      </div>
      <div style="margin: 20px 0">
        <span class="title">云诊所</span>
        <el-radio-group v-model="detail.clinic_web">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="2">不开放</el-radio>
        </el-radio-group>
        <div style="padding-left: 110px">
          <span style="margin-right: 20px">诊所设置</span>

                <span v-if="detail.clinic_count">{{ detail.clinic_count }}家</span>
                        <el-button
            v-else
            type="text"
            @click="setClinic"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('565') : false
            "
          >未设置</el-button>
                        <el-button
            v-if="detail.clinic_count"
            type="text"
            @click="setClinic(detail.drug_type)"
            style="margin-left: 10px"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('565') : false
            "
          >修改</el-button>
        </div>
      </div>
      <div>
        <span class="title">平台拍方购药</span>
        <el-radio-group v-model="detail.platform_phone">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="2">不开放</el-radio>
        </el-radio-group>
      </div>
      <div style="margin: 20px 0">
        <span class="title">平台按方购药 </span>
        <el-radio-group v-model="detail.platform_agree">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="2">不开放</el-radio>
        </el-radio-group>
      </div>
      <div style="width: 300px; text-align: center">
        <el-button
          type="primary"
          size="medium"
          @click="submit"
        >保存</el-button>
      </div>
    </div>
    <!-- 设置医生弹窗 -->
    <el-dialog
      title="请设置医生"
      :visible.sync="adddoctor"
      width="300px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px 30px">
        <el-radio
          v-model="isall_doctor"
          :label="1"
        >全部医生</el-radio>
        <el-radio
          v-model="isall_doctor"
          :label="2"
        >部分医生</el-radio>
      </div>
      <div style="padding-bottom: 20px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="setDoctor"
            size="medium"
          >确定</el-button>
          <el-button
            plain
            @click="adddoctor = false"
            size="medium"
          >取消</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {},
      adddoctor: false,
      isall_doctor: 1
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取详情
    getDetail() {
      this.axios
        .post('platform/TraditionOintment/getTraditionOintmentPortStatus')
        .then((res) => {
          this.detail = res.data.info;
        });
    },
    submit() {
      let data = this.detail;
      this.axios
        .post('platform/TraditionOintment/changeTraditionOintmentPort', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('修改成功');
            this.getDetail();
          }
        });
    },
    //设置医生
    setDoctor() {
      if (this.isall_doctor == 1) {
        let doctor_type = 1;
        this.axios
          .post('platform/TraditionOintment/saveTraditionOintmentDoctorInfo', {
            doctor_type
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success('设置成功');
              this.adddoctor = false;
              this.getDetail();
            }
          });
      } else {
        this.$router.push({
          path: 'adddoctoroil'
        });
      }
    },
    //设置诊所
    setClinic() {
      this.$router.push('addclinicoil');
    }
  },

  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  text-align: left;
}
.title {
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
  font-weight: 600;
}
</style>
